import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource-variable/inter'
import 'material-symbols/outlined.css'
import 'material-symbols/rounded.css'
import App from './App.tsx'
import { Providers } from './Providers.tsx'
import { GlobalStyles } from './GlobalStyles.tsx'
import { initDatadog } from './utils/datadog.ts'
import { captureUtmParams } from './utils/utm.ts'
import { reloadOnChunkError } from './utils/reloadOnChunkError.ts'

reloadOnChunkError();

// Initialize Datadog RUM before rendering, then capture any UTM params from
// the landing URL so they are persisted before React mounts.
initDatadog();
try { captureUtmParams(); } catch (e) { console.warn('[UTM] captureUtmParams failed', e); }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <GlobalStyles />
      <App />
    </Providers>
  </React.StrictMode>,
);
